module.exports = __webpack_public_path__ + "img/com_icon.c9cfba7b.png";